export const handleErrMessage = (err) => {
  if (err) {
    return err;
  } else {
    return "Something went wrong! Please try again.";
  }
};
